import { styled, css } from '../../style';

const StyledDiv = styled('div')(
  ({ theme }) => css`
    .token-select-modal {
      width: 482px;
      height: 520px;
      margin: 18px 9px;
    }

    @media (max-width: 775px) {
      .token-select-modal {
        width: 96%;
      }
    }

    .maximus-modal-wrapper {
      background-color: ${theme.colors.modal};
      border: ${theme.colors.cardBorder};
      border-radius: 18px;
    }

    .maximus-modal {
      background-color: ${theme.colors.modal};
    }

    .list-item-symbol {
      color: ${theme.colors.title};
    }

    .modal-title-quick {
      font-weight: bold;
      font-size: 18px;
      color: ${theme.colors.title};
    }

    .header-wrapper {
      display: flex;
      color: ${theme.colors.title};
      justify-content: space-between;
      width: 100%;
      padding: 0px 24px;
    }

    .close {
      display: flex;
      justify-content: right;
      svg {
        stroke: ${theme.colors.title} !important;
      }
    }
    .list {
      border: 1px solid #e3e3e5;
      border-radius: 18px;
      background-color: ${theme.colors.background};
      border: ${theme.colors.cardBorder};
    }

    .modal-list {
    }
  `
);

export default StyledDiv;
